import { NonDeletedSchemadrawElement } from "./types";
import { getSelectedElements } from "../scene";
import { AppState } from "../utils/types";

export const showSelectedShapeActions = (
  appState: AppState,
  elements: readonly NonDeletedSchemadrawElement[],
) =>
  Boolean(
    !appState.viewModeEnabled &&
    ((appState.activeTool.type !== "custom" &&
      (appState.editingElement ||
        (appState.activeTool.type !== "selection" &&
          appState.activeTool.type !== "eraser" &&
          appState.activeTool.type !== "hand" &&
          appState.activeTool.type !== "laser"))) ||
      getSelectedElements(elements, appState).length),
  );
